import React from 'react';
import HomeSection3 from '../../HomeSection3';
import './Terms.css'

import {
    sectionTwoObj,
} from './Data';

import '../Footer/Footer.css';

const RefundPolicy = ( lightBg ) => {
    const refundPolicyHeading = {
        ...sectionTwoObj,
        headLine: 'REFUND POLICY'
    };
    return (
        <div>
            <HomeSection3 {...refundPolicyHeading}/>

            <div className={lightBg ? 'terms__home-section' : 'terms__home-section darkBg'}>
                <div className="container">
                        <p className="terms">
                        <b>Return Policy</b>
                        <br/><br/>
                        Products must be returned to us within <b>12 days</b> from the date of delivery.
                        <br/>
                        The product must be returned in its original condition with all tags attached, along with original packing material, courier receipt, invoice, and other relevant documents.
                        <br/>
                        Products may be shipped via alternative logistics partners and may take 1–2 weeks depending on the location.
                        <br/><br/>
                        
                        <b>Refund Policy</b>
                        <br/><br/>
                        Once the product is successfully received by <b>Shenzu Spending</b>, the refund will be initiated to your original source account or your chosen method of refund.
                        <br/><br/>
                        
                        <b>Refund & Cancellation for Service Provider Company</b>
                        <br/><br/>
                        Due to the nature of services provided, <b>NO REFUND</b> and <b>NO CANCELLATION</b> will be entertained once the payment has been made.
                        <br/><br/>
                        
                        <b>Cancellation Policy</b>
                        <br/><br/>
                        An order can only be canceled within <b>24 hours</b> of placing the order.
                        <br/>
                        Once the order is processed after 24 hours, no cancellation request will be entertained. However, returns are possible for eligible products.
                        <br/><br/>
                        <b>OR</b>
                        <br/><br/>
                        Customers can cancel an order only before the order has been shipped/dispatched.
                        <br/>
                        After the product(s) have been shipped, the order cannot be canceled. However, returns are possible for eligible products.
                        <br/><br/>
                        
                        <b>Shipping & Delivery Policy</b>
                        <br/><br/>
                        Shenzu Spending ships products to almost all parts of India.
                        <br/>
                        Orders placed will be shipped within <b>24 hours*</b>. We ship on all days except Sundays and National Holidays.
                        <br/><br/>
                        For areas serviced by reputed courier partners, delivery typically takes <b>3–4 business days</b> from the date of shipping (excluding Sundays and holidays).
                        <br/>
                        For other locations, products may be shipped via <b>alternative logistics partners</b> and may take <b>1–2 weeks</b>, depending on the location.
                        <br/><br/>
                        Unexpected delays may occur due to logistics challenges beyond our control. Shenzu Spending is not liable for such delays and requests customers’ cooperation.
                        <br/>
                        Shenzu Spending reserves the right to cancel orders at its discretion if delivery takes longer than usual or if the shipment is untraceable. In such cases, the paid amount will be refunded to the source account.
                        <br/><br/>    
                        <br/><br/>
                        Last Updated: 04-02-2026
                        <br/><br/>
                        
                    </p>
                </div>
            </div>
        </div>
    )
}

export default RefundPolicy;
